import { queryOptions } from '@tanstack/react-query';
import { api } from '../../lib/api';
import { wallPollMs } from './wallFormat';

/**
 * Wall list and detail queries. Both keep polling while the tab is in the background, so an
 * operator who switches to a player window does not come back to a wall view frozen on an
 * old device (86bcwe9nd, run 3: refetchInterval paused in the background and the 30 s
 * staleTime skipped the refetch on focus).
 */
export function videoWallsQuery(organisationId: string) {
  return queryOptions({
    queryKey: ['video-walls', organisationId],
    queryFn: () => api.listVideoWalls(organisationId),
    refetchInterval: (query) => {
      const intervals = (query.state.data ?? [])
        .map((wall) => wallPollMs(wall.operations.state))
        .filter((ms): ms is number => ms !== false);
      return intervals.length ? Math.min(...intervals) : false;
    },
    refetchIntervalInBackground: true,
  });
}

export function videoWallDetailQuery(organisationId: string, wallId: string | null) {
  return queryOptions({
    queryKey: ['video-wall', organisationId, wallId],
    queryFn: () => api.getVideoWall(organisationId, wallId!),
    enabled: Boolean(wallId),
    refetchInterval: (query) => wallPollMs(query.state.data?.operations.state),
    refetchIntervalInBackground: true,
  });
}
